import Actions from '../../odata/actions';

const actions = new Actions('reportAdjustment', 'reportAdjustments');

export default actions;
